import moment from 'moment'
import { formatDays } from 'apps/carrier/components/GeneralInformation/SavedLanes/SavedLanesTable/SavedLanesTableRow/SavedLanesTableCells/utils'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'

export const getPickup = ({
  pickupIsoDaysOfWeek,
  pickupStartDate,
}: Pick<BookableShipmentSavedSearch, 'pickupStartDate' | 'pickupIsoDaysOfWeek'>): string => {
  if (!pickupStartDate && !pickupIsoDaysOfWeek) {
    return 'Pickup Any Day'
  }

  if (pickupStartDate) {
    return `Pickup ${moment(pickupStartDate).format('M/D')}`
  }

  const numberOfPickupDays = pickupIsoDaysOfWeek?.length || 0

  if (numberOfPickupDays > 0 && numberOfPickupDays < 7) {
    return `Pickup ${formatDays(pickupIsoDaysOfWeek || [])}`
  }

  return 'Pickup Any Day'
}
